export const getDateTimeSchema = (date: any, schema: any) => {
    if (schema.is_required) date = date.required()
    return date
}
